export const cameraCategoryData = {
  micro: [
    {
      id: 1,
      slug: "2mp-hd-dome-camera",
      title: "2MP Full HD IR Dome CCTV Camera",
      brand: "SecureVision Pro",
      img: "https://images.unsplash.com/photo-1581091870627-3d3c6d1f3b3c",
      shortDescription:
        "Professional 2MP indoor dome camera with smart night vision and motion detection alerts.",

      price: "₹2,499",

      features: [
        "Full HD 1080p Resolution",
        "Smart IR Night Vision up to 30m",
        "Wide Dynamic Range (WDR)",
        "Motion Detection with Mobile Alerts",
        "Waterproof IP66 Rated",
        "3D Digital Noise Reduction",
      ],

      specifications: {
        cameraType: "Dome Camera",
        resolution: "1920 × 1080 (2MP)",
        lens: "3.6mm Fixed Lens",
        imageSensor: "1/2.7” CMOS Sensor",
        nightVision: "Up to 30 meters",
        videoOutput: "HD Analog (AHD/TVI/CVI/CVBS)",
        weatherproof: "IP66",
        operatingTemperature: "-20°C to +60°C",
        powerSupply: "DC 12V",
        warranty: "2 Years Manufacturer Warranty",
      },

      installation: {
        recommendedFor: "Indoor – Offices, Shops, Homes",
        mountingType: "Ceiling Mount",
        installationSupport: "Professional installation available",
      },

      packageIncludes: [
        "1 x Dome Camera",
        "Mounting Screws",
        "User Manual",
        "Warranty Card",
      ],

      certifications: ["CE", "FCC", "RoHS"],
    },
    {
      id: 2,
      slug: "2mp-hd-dome-camera",
      title: "2MP Full HD IR Dome CCTV Camera",
      brand: "SecureVision Pro",
      img: "https://images.unsplash.com/photo-1581091870627-3d3c6d1f3b3c",
      shortDescription:
        "Professional 2MP indoor dome camera with smart night vision and motion detection alerts.",

      price: "₹2,499",

      features: [
        "Full HD 1080p Resolution",
        "Smart IR Night Vision up to 30m",
        "Wide Dynamic Range (WDR)",
        "Motion Detection with Mobile Alerts",
        "Waterproof IP66 Rated",
        "3D Digital Noise Reduction",
      ],

      specifications: {
        cameraType: "Dome Camera",
        resolution: "1920 × 1080 (2MP)",
        lens: "3.6mm Fixed Lens",
        imageSensor: "1/2.7” CMOS Sensor",
        nightVision: "Up to 30 meters",
        videoOutput: "HD Analog (AHD/TVI/CVI/CVBS)",
        weatherproof: "IP66",
        operatingTemperature: "-20°C to +60°C",
        powerSupply: "DC 12V",
        warranty: "2 Years Manufacturer Warranty",
      },

      installation: {
        recommendedFor: "Indoor – Offices, Shops, Homes",
        mountingType: "Ceiling Mount",
        installationSupport: "Professional installation available",
      },

      packageIncludes: [
        "1 x Dome Camera",
        "Mounting Screws",
        "User Manual",
        "Warranty Card",
      ],

      certifications: ["CE", "FCC", "RoHS"],
    },
    {
      id: 3,
      slug: "2mp-hd-dome-camera",
      title: "2MP Full HD IR Dome CCTV Camera",
      brand: "SecureVision Pro",
      img: "https://images.unsplash.com/photo-1581091870627-3d3c6d1f3b3c",
      shortDescription:
        "Professional 2MP indoor dome camera with smart night vision and motion detection alerts.",

      price: "₹2,499",

      features: [
        "Full HD 1080p Resolution",
        "Smart IR Night Vision up to 30m",
        "Wide Dynamic Range (WDR)",
        "Motion Detection with Mobile Alerts",
        "Waterproof IP66 Rated",
        "3D Digital Noise Reduction",
      ],

      specifications: {
        cameraType: "Dome Camera",
        resolution: "1920 × 1080 (2MP)",
        lens: "3.6mm Fixed Lens",
        imageSensor: "1/2.7” CMOS Sensor",
        nightVision: "Up to 30 meters",
        videoOutput: "HD Analog (AHD/TVI/CVI/CVBS)",
        weatherproof: "IP66",
        operatingTemperature: "-20°C to +60°C",
        powerSupply: "DC 12V",
        warranty: "2 Years Manufacturer Warranty",
      },

      installation: {
        recommendedFor: "Indoor – Offices, Shops, Homes",
        mountingType: "Ceiling Mount",
        installationSupport: "Professional installation available",
      },

      packageIncludes: [
        "1 x Dome Camera",
        "Mounting Screws",
        "User Manual",
        "Warranty Card",
      ],

      certifications: ["CE", "FCC", "RoHS"],
    },
    {
      id: 4,
      slug: "2mp-hd-dome-camera",
      title: "2MP Full HD IR Dome CCTV Camera",
      brand: "SecureVision Pro",
      img: "https://images.unsplash.com/photo-1581091870627-3d3c6d1f3b3c",
      shortDescription:
        "Professional 2MP indoor dome camera with smart night vision and motion detection alerts.",

      price: "₹2,499",

      features: [
        "Full HD 1080p Resolution",
        "Smart IR Night Vision up to 30m",
        "Wide Dynamic Range (WDR)",
        "Motion Detection with Mobile Alerts",
        "Waterproof IP66 Rated",
        "3D Digital Noise Reduction",
      ],

      specifications: {
        cameraType: "Dome Camera",
        resolution: "1920 × 1080 (2MP)",
        lens: "3.6mm Fixed Lens",
        imageSensor: "1/2.7” CMOS Sensor",
        nightVision: "Up to 30 meters",
        videoOutput: "HD Analog (AHD/TVI/CVI/CVBS)",
        weatherproof: "IP66",
        operatingTemperature: "-20°C to +60°C",
        powerSupply: "DC 12V",
        warranty: "2 Years Manufacturer Warranty",
      },

      installation: {
        recommendedFor: "Indoor – Offices, Shops, Homes",
        mountingType: "Ceiling Mount",
        installationSupport: "Professional installation available",
      },

      packageIncludes: [
        "1 x Dome Camera",
        "Mounting Screws",
        "User Manual",
        "Warranty Card",
      ],

      certifications: ["CE", "FCC", "RoHS"],
    },
  ],

  drone: [
    {
      id: 1,
      slug: "5mp-outdoor-bullet-camera",
      title: "5MP Ultra HD Outdoor Bullet Camera",
      brand: "SecureVision Elite",
      img: "https://images.unsplash.com/photo-1597002973712-c0b4f0b7b7d7",
      shortDescription:
        "Advanced 5MP outdoor bullet camera with long-range IR and metal housing for extreme durability.",
      price: "₹4,999",

      features: [
        "5MP Ultra HD Video",
        "IR Night Vision up to 80m",
        "Metal Body with IP67 Waterproof",
        "Smart Motion Detection",
        "Backlight Compensation (BLC)",
        "Mobile App Remote Viewing",
      ],

      specifications: {
        cameraType: "Bullet Camera",
        resolution: "2560 × 1920 (5MP)",
        lens: "6mm Fixed Lens",
        imageSensor: "Sony STARVIS Sensor",
        nightVision: "Up to 80 meters",
        weatherproof: "IP67",
        videoCompression: "H.265+",
        operatingTemperature: "-30°C to +70°C",
        powerSupply: "DC 12V / PoE",
        warranty: "3 Years Manufacturer Warranty",
      },

      installation: {
        recommendedFor: "Outdoor – Parking, Warehouses, Buildings",
        mountingType: "Wall Mount",
        installationSupport: "On-site installation available",
      },

      packageIncludes: [
        "1 x Bullet Camera",
        "Wall Mount Bracket",
        "Waterproof Connector",
        "Warranty Card",
      ],

      certifications: ["CE", "FCC", "ISO9001"],
    },
  ],

  microphone: [
    {
      id: 1,
      slug: "8mp-4k-ptz-camera",
      title: "8MP 4K PTZ Smart CCTV Camera",
      brand: "SecureVision Ultra",
      img: "https://images.unsplash.com/photo-1508615070457-7baeba4003ab",
      shortDescription:
        "Premium 4K PTZ camera with 360° rotation, 20x optical zoom and AI tracking.",

      price: "₹24,999",

      features: [
        "4K Ultra HD Resolution",
        "360° Pan & 90° Tilt",
        "20x Optical Zoom",
        "Auto Tracking AI Technology",
        "Two-Way Audio",
        "Night Vision up to 150m",
      ],

      specifications: {
        cameraType: "PTZ Camera",
        resolution: "3840 × 2160 (8MP)",
        zoom: "20x Optical Zoom",
        panTilt: "360° Pan / 90° Tilt",
        nightVision: "Up to 150 meters",
        storage: "Supports up to 256GB SD Card",
        videoCompression: "H.265+",
        powerSupply: "PoE+",
        operatingTemperature: "-40°C to +65°C",
        warranty: "3 Years",
      },

      installation: {
        recommendedFor: "Large Areas – Malls, Airports, Factories",
        mountingType: "Wall / Pole Mount",
        installationSupport: "Certified technician required",
      },

      packageIncludes: [
        "1 x PTZ Camera",
        "Power Adapter",
        "Mounting Kit",
        "User Manual",
      ],

      certifications: ["CE", "FCC", "ISO9001", "IP66"],
    },
  ],

  wifi: [
    {
      id: 1,
      slug: "wireless-wifi-security-camera",
      title: "Wireless WiFi Smart CCTV Camera",
      brand: "SecureVision Smart",
      img: "https://images.unsplash.com/photo-1581090700227-4c4f50b8c2f5",
      shortDescription:
        "Plug & Play WiFi CCTV camera with mobile app access and cloud storage support.",

      price: "₹3,299",

      features: [
        "1080p Full HD Recording",
        "Built-in WiFi Connectivity",
        "Two-Way Audio Communication",
        "Cloud Storage Support",
        "Motion & Sound Detection",
        "Mobile App (Android & iOS)",
      ],

      specifications: {
        cameraType: "WiFi Smart Camera",
        resolution: "1920 × 1080",
        connectivity: "2.4GHz WiFi",
        storage: "Supports 128GB SD Card",
        audio: "Built-in Mic & Speaker",
        nightVision: "Up to 20m",
        powerSupply: "USB 5V Adapter",
        operatingTemperature: "0°C to +50°C",
        warranty: "1 Year",
      },

      installation: {
        recommendedFor: "Homes, Apartments, Baby Monitoring",
        mountingType: "Table / Wall Mount",
        installationSupport: "Self Installation (Plug & Play)",
      },

      packageIncludes: [
        "1 x WiFi Camera",
        "USB Cable",
        "Power Adapter",
        "Quick Start Guide",
      ],

      certifications: ["CE", "RoHS"],
    },
  ],
};